/**
 * 行程被选择的日期（详情、编辑、地图模式共享）
 * URL的参数比其优先级更高
 */

import {SELECT_TRIP_DAY} from '../../actionTypes';

export default function reducer(state = 0, action) {
  if (action.type === SELECT_TRIP_DAY) {
    return action.data;
  } else {
    return state;
  }
}



// WEBPACK FOOTER //
// ./src/store/reducers/trip/selectedDay.js